export class ProbeFailedResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "detail",
            "baseName": "detail",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "ProbeFailedResponseError",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ProbeFailedResponse.attributeTypeMap;
    }
    constructor() {
    }
}
